// import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/tooltips'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import VueI18n from 'vue-i18n'
import Langs from './langs'
import axios from 'axios'

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: window.localStorage.getItem('locale') || 'en',
  messages: Langs,
})

axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response
    if (status === 401) {
      store.dispatch('auth/logOut').then(() => {
        store.commit('data/SET_DICTIONARY_LOADING_STATUS', false)
        router.push({ name: 'login' })
      })
    }
    return Promise.reject(error)
  }
)

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}
